
let pageConfig = {};

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '占位订单管理'
    },
];

// 列表展示项
pageConfig.listColumns = [
    {
        label: '订单编号',
        props: 'orderNo',
        minWidth: 240,
    },
    {
        label: '型号名称',
        props: 'pileTypeCode',
        minWidth: 200,
    },
    {
        label: '充电网点',
        props: 'stationName',
        minWidth: 200,
    },
    {
        label: '订单金额（元）',
        props: 'totalFee',
        minWidth: 200,
        tooltip: true,
    },
    {
        label: '充电费（元）',
        props: 'actFee',
        minWidth: 200,
    },
    {
        label: '占位费（元）',
        props: 'occupyFee',
        minWidth: 120,
    },
    {
        label: '订单状态',
        props: 'chargeStepName',
        minWidth: 180,
    },
    {
        label: '异常类型',
        props: 'abnormalCause',
        minWidth: 240,
    },
    {
        label: '最终SOC电量',
        props: 'soc',
        minWidth: 160,
    },
    {
        label: '充电情况',
        props: 'chargeProcess',
        minWidth: 240,
    },
    {
        label: '处理状态',
        props: 'processingStatusName',
        minWidth: 180,
    },
    {
        label: '车主电话',
        props: 'custPhone',
        minWidth: 180,
    },
    {
        label: '开始充电时间',
        props: 'beginTime',
        minWidth: 200,
    },
    {
        label: '结束充电时间',
        props: 'endTime',
        minWidth: 200,
    },
    {
        label: '结算订单时间',
        props: 'lastModifiedWhen',
        minWidth: 200,
    },
    {
        label: '创建者',
        props: 'createdByName',
        minWidth: 160,
    },
    {
        label: '创建时间',
        props: 'createdWhen',
        minWidth: 200,
    },
    {
        label: '更新者',
        props: 'lastModifiedByName',
        minWidth: 160,
    },
    {
        label: '更新时间',
        props: 'lastModifiedWhen',
        minWidth: 200,
    },
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
};

// 弹框验证
pageConfig.rules = {
    processingStatus: [
        { required: true, message: '请选择处理结果', trigger: 'change' }
    ],
    occupyHandle:[
        { required: true, message: '请选择占位费处理方式', trigger: 'change' }
    ],
    occupyHandleFee: [
        { required: true, message: '请输入金额', trigger: 'blur' }
    ],
    handlerRemark: [
        { required: true, message: '请填写活动形式', trigger: 'blur' }
    ]
};

// 弹窗 处理 列表展示项（处理）
pageConfig.popListColumns = [
    {
        label: '操作时间',
        props: 'lastModifiedWhen',
        minWidth: 180,
    },
    {
        label: '操作人',
        props: 'lastModifiedByName',
        minWidth: 140,
    },
    {
        label: '操作事项',
        props: 'content',
        minWidth: 360,
    },
];
// 弹窗 处理 列表展示项（查看详情）
pageConfig.popDetailListColumns = [
    {
        label: '开始时间',
        props: 'startTime',
        minWidth: 160,
    },
    {
        label: '结束时间',
        props: 'endTime',
        minWidth: 160,
    },
    {
        label: '内容',
        props: 'content',
        minWidth: 360,
    },
    {
        label: '费用',
        props: 'totalFee',
        minWidth: 120,
    },
];
// 弹框表格属性
pageConfig.popTableConfig = {
    showSelection: false,
    showIndex: false,
    maxHeight: 240,
};

// 弹框表格操作配置
pageConfig.operates = {
    width: 180,
    fixed: "right",
    list: []
};


export default pageConfig;
